'use client';
import cn from 'classnames';
import SwitchComponent from 'react-switch';

import './Switch.style.scss';

type SwitchProps = {
  className?: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  height?: number;
  width?: number;
  handleDiameter?: number;
};

function Switch(props: SwitchProps) {
  const {
    className = '',
    checked,
    onChange,
    height = 20,
    width = 48,
    handleDiameter = 20
  } = props;

  return (
    <div className={cn('Switch', className)}>
      <SwitchComponent
        checked={checked}
        onChange={onChange}
        onColor='#FF8DA1'
        checkedIcon={false}
        uncheckedIcon={false}
        handleDiameter={handleDiameter}
        boxShadow='0px 1px 5px rgba(0, 0, 0, 0.6)'
        activeBoxShadow='0px 0px 1px 10px rgba(0, 0, 0, 0.2)'
        height={height}
        width={width}
      />
    </div>
  );
}

export default Switch;
